import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CONTACT_PATH } from '@/config/site';

export default function LandingHero() {
    return (
        <>
            <style>{`
                #home-hero-bg {
                  background-color: #fafafa;
                  background-image:
                    radial-gradient(ellipse 80% 50% at 80% 0%, rgba(139, 92, 246, 0.16), transparent),
                    radial-gradient(ellipse 60% 40% at 10% 20%, rgba(117, 163, 108, 0.12), transparent);
                  background-repeat: no-repeat;
                }
            `}</style>

            <section id="home-hero-bg" className="flex flex-col items-center text-sm bg-white pb-40 relative min-h-[804px] justify-center">
                <main className="container mx-auto px-6 md:px-16 lg:px-24 xl:px-32 flex flex-col items-start w-full pt-48 relative z-10 ">

                    <motion.h1
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-left text-4xl md:text-5xl lg:text-[52px] font-extrabold max-w-2xl text-slate-800 uppercase leading-[1.1] tracking-tight mt-28"
                    >
                        Potencialize a gestão <br /> do seu posto de <br /> combustível com a <br />
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 drop-shadow-sm">
                           LUKOS
                        </span>
                    </motion.h1>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.3 }}
                        className="mt-10"
                    >
                        <p className="text-left text-lg md:text-xl text-slate-600 font-medium max-w-xl leading-relaxed">
                            Tenha total controle do seu negócio em tempo real, elimine dores de cabeça com o fisco e recupere o tempo livre para focar no que importa: <b>lucrar</b>.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.5 }}
                        className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mt-12 w-full max-w-xl"
                    >
                        <Link
                            to={CONTACT_PATH}
                            className="flex items-center justify-center bg-purple-600 hover:bg-purple-700 text-white font-black rounded-2xl px-8 sm:px-12 h-16 min-w-0 sm:min-w-[280px] text-xs uppercase tracking-[0.2em] transition-all active:scale-95 shadow-[0_25px_50px_-12px_rgba(147,51,234,0.3)]"
                        >
                            Falar com Especialista
                        </Link>

                        <a
                            href="https://erponline.lukia.com.br/login"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center h-16 px-8 rounded-2xl border-2 border-slate-200 text-slate-700 font-black text-xs uppercase tracking-[0.2em] hover:border-purple-300 hover:text-purple-700 transition-all active:scale-95"
                        >
                            Já sou cliente — Acessar o ERP
                        </a>

                    </motion.div>

                </main>

                {/* Scroll Down Button */}

            </section>
        </>
    );
}
